import type { HubResponseProps } from '@readme/iso';
import type { PropsWithChildren } from 'react';

import React from 'react';

import useClassy from '@core/hooks/useClassy';
import { ConnectSuperHubStoreToRouter, InitializeSuperHubVersions } from '@core/store';

import { SuperHubContextProvider } from './components/Context';
import classes from './index.module.scss';

/**
 * Renders superhub content for non-admin users with view-only access.
 */
export default function ViewContainer({ children, versions }: PropsWithChildren<HubResponseProps>) {
  const bem = useClassy(classes, 'SuperHub');

  return (
    <SuperHubContextProvider>
      <InitializeSuperHubVersions initialVersions={versions}>
        <ConnectSuperHubStoreToRouter>
          <div className={bem()}>{children}</div>
        </ConnectSuperHubStoreToRouter>
      </InitializeSuperHubVersions>
    </SuperHubContextProvider>
  );
}
